import { Box, Flex, Text } from '@radix-ui/themes';
import { ChartItem, ValueFormatter } from '.';
import { TruncatedTooltip } from '../TruncatedTooltip';

interface ChartLegendProps {
    items: ChartItem[];
    valueKey: keyof ChartItem;
    hoveredName?: string;
    onHover?: (name: string | undefined) => void;
    valueFormatter?: ValueFormatter;
}

export const ChartLegend = ({
    items,
    valueKey,
    hoveredName,
    onHover,
    valueFormatter,
}: ChartLegendProps) => (
    <Flex direction='column' gap='0'>
        {items.map((item) => {
            const isActive = hoveredName === item.name;
            // const isDimmed = hoveredName !== null && !isActive;

            const rawValue = valueKey ? item[valueKey] : undefined;
            const displayValue =
                valueFormatter && rawValue !== undefined
                    ? valueFormatter(rawValue)
                    : rawValue;

            return (
                <Flex
                    key={item.name}
                    align={'center'}
                    onMouseEnter={() => onHover?.(item.name)}
                    onMouseLeave={() => onHover?.(undefined)}
                    width={'fit-content'}
                    gap={'3'}
                    style={{
                        padding: '0 var(--space-1)',
                        userSelect: 'none',
                        // opacity: isDimmed ? 0.4 : 1,
                        // backgroundColor: isActive
                        //     ? 'var(--gray-a3)'
                        //     : 'transparent',
                        transition: 'all 0.2s ease',
                        borderRadius: 'var(--radius-1)',
                    }}
                >
                    <Flex gap={'2'} align={'center'}>
                        <Box
                            width={'8px'}
                            height={'8px'}
                            style={{
                                borderRadius: '50%',
                                backgroundColor: item.fill,
                                boxShadow: isActive
                                    ? `0 0 8px ${item.fill}`
                                    : 'none',
                            }}
                        />

                        <Text
                            size={'2'}
                            color='gray'
                            highContrast={isActive}
                            asChild
                        >
                            <TruncatedTooltip maxWidth='100%'>
                                {item.name}
                            </TruncatedTooltip>
                        </Text>
                    </Flex>

                    {displayValue && (
                        <Text
                            size={'2'}
                            // weight={isActive ? 'bold' : 'medium'}
                            color={isActive ? undefined : 'gray'}
                            highContrast={false}
                        >
                            {displayValue}
                        </Text>
                    )}
                </Flex>
            );
        })}
    </Flex>
);
